// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jSuT0u2wDOCA2dcvVEbJ {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 25vw;
  min-width: 15rem;
}
.jSuT0u2wDOCA2dcvVEbJ .YVZfDiqtcy6fDuqWh4zR {
  text-decoration: none;
  color: white;
  font-size: clamp(15px, 2vw, 25px);
  text-align: center;
  text-shadow: 2px 2px 2px black;
  width: 25vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.jSuT0u2wDOCA2dcvVEbJ .TTRgHQ3vG_GWHBJqZOqA {
  width: 25vw;
  min-width: 12rem;
  border-radius: 10px;
  box-shadow: 5px 5px 4px black;
}
.jSuT0u2wDOCA2dcvVEbJ .TTRgHQ3vG_GWHBJqZOqA:hover {
  box-shadow: 10px 10px 10px gold;
}
.jSuT0u2wDOCA2dcvVEbJ .RGLPJR3RTB76B97J7s5Q {
  font-size: clamp(17px, 2.5vw, 27px);
  margin: 0;
  color: white;
  text-shadow: 2px 2px 2px black;
}`, "",{"version":3,"sources":["webpack://./src/components/GameListItem/GameListItem.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;AACJ;AACI;EACI,qBAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AACR;AACI;EACI,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;AACR;AAEI;EAEI,+BAAA;AADR;AAGI;EACI,mCAAA;EACA,SAAA;EACA,YAAA;EACA,8BAAA;AADR","sourcesContent":[".gameListItem {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 25vw;\n    min-width: 15rem;\n\n    .link {\n        text-decoration: none;\n        color: white;\n        font-size: clamp(15px, 2vw, 25px);\n        text-align: center;\n        text-shadow: 2px 2px 2px black;\n        width: 25vw;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n    }\n    .image {\n        width: 25vw;\n        min-width: 12rem;\n        border-radius: 10px;\n        box-shadow: 5px 5px 4px black;\n\n    }\n    .image:hover {\n        \n        box-shadow: 10px 10px 10px  gold;\n    }\n    .price {\n        font-size: clamp(17px, 2.5vw, 27px);\n        margin: 0;\n        color: white;\n        text-shadow: 2px 2px 2px black;\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gameListItem": `jSuT0u2wDOCA2dcvVEbJ`,
	"link": `YVZfDiqtcy6fDuqWh4zR`,
	"image": `TTRgHQ3vG_GWHBJqZOqA`,
	"price": `RGLPJR3RTB76B97J7s5Q`
};
export default ___CSS_LOADER_EXPORT___;
